module.exports = __webpack_public_path__ + "static/media/Stackers-dt-en.89eae425.jpg";